import LazyPlaceholder from './LazyPlaceholder';
import LazyPlaceholderV2 from '../../lego.editor_comment/LazyPlaceholder';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: LazyPlaceholderV2
})(LazyPlaceholder);

//# sourceMappingURL=index.js.map